var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcVendorReward = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic_vendor_reward_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.245 20c1.125 0 2.05-.92 2.05-2.05V9.86H3.705v8.09c0 1.125.92 2.05 2.05 2.05h12.49Z",
  fill: "#CAE7FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.29 8.84a.917.917 0 0 0 .89-1.145L19.54 3.09a.915.915 0 0 0-.89-.695H5.355c-.42 0-.79.285-.89.695 0 0-1.22 3.235-1.64 4.605-.175.575.295 1.145.89 1.145H20.29Z",
  fill: "#A3D3FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16 14.18-4 6.93h2.86L16 19.13l1.14 1.98H20l-4-6.93Z",
  fill: "#1049B7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 18.75a3.43 3.43 0 1 0 0-6.86 3.43 3.43 0 1 0 0 6.86Z",
  fill: "#2D91FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic_vendor_reward_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgIcVendorReward;